export default "__VITE_ASSET__DzhNd_9B__"